import NtxTable from '@components/DataTable/NtxTable';
import React from 'react';
import { useTranslation } from 'react-i18next';

function PayProposalTableList({ PayProposalList }) {
  const { t } = useTranslation();

  console.log(PayProposalList);

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Value'), key: 'value' },
    { title: t('Start Date'), key: 'start' },
    { title: t('Date_TO'), key: 'end' },
    { title: t('Reason'), key: 'reason' },
    { title: t('Note'), key: 'note' }
  ];

  const tableData = PayProposalList?.slice()
    ?.sort((a, b) => new Date(b.changeDate) - new Date(a.changeDate))
    ?.map(item => {
      // let rowClass;

      return {
        value: (
          <span className='text-theme fw-bold fs-5'>{item.proposedSalaryN?.toLocaleString()}</span>
        ),
        start: item.changeDate,
        end: item.dateTo ? item.dateTo : <span className='badge bg-info text-dark'>حتى الآن</span>,
        reason: item.proposalReason,
        note: item.comments
      };
    });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  return (
    <>
      {/* <div className='table-responsive rounded-2 text-center'>
        <table className='table table-hover text-nowrap mb-0'>
          <thead className='bg-theme bg-opacity-30'>
            <tr>
              <th scope='col'>{t('Value')}</th>
              <th scope='col'> {t('Start Date')}</th>
              <th scope='col'> {t('Date_TO')}</th>
              <th scope='col'>{t('Reason')}</th>
            </tr>
          </thead>

          <tbody>
            {PayProposalList &&
              PayProposalList?.map(item => (
                <tr key={item.id}>
                  <td className='align-middle'>{item.proposedSalaryN}</td>
                  <td className='align-middle'>{item.changeDate}</td>
                  <td className='align-middle'>{item.dateTo ? item.dateTo : ' __ حتى الأن __'}</td>
                  <td className='align-middle'>{item.proposalReason}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div> */}

      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table text-nowrap table-hover '
        // enableSearch
        // showRecordsSelector
      />
    </>
  );
}

export default PayProposalTableList;
